import { toast } from 'react-toastify';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchFundLists } from '../../../utilities/preQualServices';

export const fetchPreQualFundsList = createAsyncThunk(
    'fetchFundsList', fetchFundLists
)


const initialState = {
    value: [{
        fundGroup: "--",
        value: "--",
        phoneNumber: "--",
        key: "--",
        fundID: "--",
        displayName: "--",
        fundInsKey: "--",
        fundName: "--"
    }],
    status: false
}

const preQualFundsListSlice = createSlice({
    name: 'fetchFundsList',
    initialState,
    reducers: {
        resetFundLists: (state) => {
            state.value = [{
                fundGroup: "--",
                value: "--",
                phoneNumber: "--",
                key: "--",
                fundID: "--",
                displayName: "--",
                fundInsKey: "--",
                fundName: "--"
            }]
            state.status = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPreQualFundsList.pending, (state, action) => {
                // toast.warn("fetchPreQualFundsList pending")
                state.status = false
            })
            .addCase(fetchPreQualFundsList.fulfilled, (state, action) => {
                const arr = []
                state.status = true
                action?.payload?.length > 0 && action?.payload?.map((data) => {
                    const obj = {
                        fundGroup: data?.FundGroup,
                        value: data?.DisplayName,
                        displayName: data?.DisplayName,
                        phoneNumber: data?.PhoneNumber,
                        key: data?.FundID,
                        fundID: data?.FundID,
                        fundInsKey: data?.FundInsKey,
                        fundName: data?.FundName
                    }
                    arr.push(obj)
                    state.value = arr
                })
                // toast.success("preQualFundsList Fetched Successfully")
            })
            .addCase(fetchPreQualFundsList.rejected, (state, action) => {
                toast.error(action.error.message)
                state.status = false
            })
    },
})

export const { resetFundLists } = preQualFundsListSlice.actions

export default preQualFundsListSlice.reducer